import Layout from 'components/Layout';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import FeaturesTpl from 'templates/FeaturesTpl';

const Tpl = props => (
  <Layout location={props.location}>
    <FeaturesTpl {...props} />
  </Layout>
);
const Features = props => {
  const data = useStaticQuery(graphql`
    query NlFeaturesQuery {
      featuresPage: nlFeaturesJson {
        title
        meta {
          description
        }
        featuresBanner {
          heading
          subheading
          btnText
        }
        features {
          heading
          content
          list
          img {
            publicURL
          }
          link {
            text
            to
          }
          isNew
        }
        featureHeading {
          heading
        }
        featuresList {
          heading
          description
          label
          linkTo
          img {
            publicURL
          }
        }
        videos {
          links
        }
        freeTrial {
          heading
          subheading
          btnText
        }
      }
      customersPage: customersJson {
        testimonial {
          heading
          list {
            logo {
              img {
                publicURL
              }
              alt
            }
            heading
            position
            name
            pick3
          }
        }
      }
    }
  `);
  return (<Tpl data={data} {...props} />)
};

Tpl.propTypes = {
  location: PropTypes.object,
};

export default Features;
